import React, { useEffect, useState, useRef, useMemo } from 'react';
import QrScanner from './QrScanner';
import { getDDMMYYYY, getHHMM } from '../../../utils/dateTimeFormats';
import {
  Alert,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Fab,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Popover,
  Select,
  Snackbar,
  Tab,
  Tabs,
  Typography,
  useTheme,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { CalendarIcon } from '@mui/x-date-pickers';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';
import NavbarLayout from '../../../common/NavbarLayout';
import { FastfoodOutlined } from '@mui/icons-material';
import { variants } from '../../../variants/variants';
import { useNavigate } from 'react-router-dom';
import {
  useAddAttendanceMutation,
  useAddScannedDataMutation,
  useGetAttendanceQuery,
  useGetDataOfDateRangeQuery,
  useGetRegionSnacksQuery,
  useGetReviewByDateRangeQuery,
  useGetScannedDataByDateQuery,
  useGetSnacksQuery,
  useGetVoteQuery,
} from '../teaAndSnacksApiSlice';
import { useLogoutMutation } from '../../Auth/authApiSlice';
import { clearAuth } from '../../Auth/Utility/ClearAuth';
import { useDispatch } from 'react-redux';
import toast from 'react-hot-toast';
import UserDataTable from './UserDataTable';
import DetailsCard from './DetailsCard';
import SnackDataForm from './SnackDataForm';
import EditSnackForm from './EditSnackForm';
import locationIcon from '../../../assets/TeaAndSnacks/location.png';
import { current } from '@reduxjs/toolkit';
import useInitializeSocket from '../../../hooks/sockets/useInitializeSocket';
import LikesModal from '../../Gnn/components/LikesModal';
import { set } from 'lodash';

var showSnackbar = null;
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const VendorPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [location, setLocation] = useState('');
  const [scannedUsers, setScannedUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isPrimaryLoading, setIsPrimaryLoading] = useState(true);
  const [snackbarData, setSnackbarData] = useState(null);
  const [scannedCount, setScannedCount] = useState({
    totalVotes: 0,
    morning: 0,
    evening: 0,
    snack: 0,
    healthy: 0,
  });
  let selectedLocation = localStorage.getItem('location');
  let currentLocation = !selectedLocation ? location : selectedLocation;
  const socket = useInitializeSocket();
  const [highlightIndex, setHighlightIndex] = useState(null);
  const [selectedFloor, setSelectedFloor] = useState(0);
  const [isSnackEntered, setIsSnackEntered] = useState(false);
  const [isCameraOpen, setIsCameraOpen] = useState(true);
  const [processedData, setProcessedData] = useState({});
  const [ratingData, setRatingData] = useState({});
  showSnackbar = setSnackbarData;
  const [logout] = useLogoutMutation();
  const currentDate = new Date(new Date().toDateString()).getTime();
  const {
    data: regionSnacks,
    isLoading: regionSnacksLoading,
    isError: regionSnacksError,
    refetch: regionSnacksDataRefetch,
  } = useGetRegionSnacksQuery(
    { date: currentDate, region: selectedLocation },
    {
      skip: !currentLocation,
    }
  );

  // State for Date Filter
  const [dateFilter, setDateFilter] = useState(null);
  const [openVotesPopup, setVotesPopup] = useState(false);
  const [dateRangeFilter, setDateRangeFilter] = useState([new Date(), new Date()]);
  const [isDatePickerOpen, setDatePickerOpen] = useState(false);
  const qrScannerRef = useRef(null);
  const {
    data: scannedData,
    isLoading: scannedDataLoading,
    isError: scannedDataError,
  } = useGetScannedDataByDateQuery({ floor: selectedFloor, region: selectedLocation || location });

  const {
    data: dataOfDateRange,
    isLoading: dataOfDateRangeLoading,
    isError: dataOfDateRangeError,
  } = useGetDataOfDateRangeQuery({
    from: new Date(dateRangeFilter[0].toDateString()).getTime(),
    to: new Date(dateRangeFilter[1].toDateString()).getTime(),
    region: selectedLocation || location,
  });
  const locations = ['Ahmedabad', 'Rajkot', 'Vadodara', 'Pune', 'Gandhinagar'];
  const [isLocationSelected, setIsLocationSelected] = useState(false);
  const [regionSnacksData, setRegionSnacksData] = useState(null);
  const {
    data: dataOfReviewDateRange,
    isLoading: dataOfReviewDateRangeLoading,
    isError: dataOfReviewDateRangeError,
  } = useGetReviewByDateRangeQuery({
    from: new Date(dateRangeFilter[0].toDateString()).getTime(),
    to: new Date(dateRangeFilter[1].toDateString()).getTime(),
    region: selectedLocation || location,
  });

  const [addScannedData] = useAddScannedDataMutation();

  const {
    data: snacksData,
    isLoading: snacksLoading,
    isError: snacksError,
  } = useGetSnacksQuery({
    skip: !currentLocation,
  });
  const [dialog, setDialog] = useState(false);
  const invalidQrCount = useRef(0);

  const {
    data: attendanceData,
    isLoading: attendanceDataLoading,
    isError: attendanceDataError,
    refetch: refetchAttendance,
  } = useGetAttendanceQuery({ date: currentDate });
  const [addAttendance] = useAddAttendanceMutation();
  const [attendanceLength, setAttendanceLength] = useState(0);
  const skip = !currentLocation;
  const {
    data: snacksVote,
    isLoading: snacksVoteLoading,
    isError: snacksVoteError,
    refetch: snacksVoteDataRefetch,
    isUninitialized,
  } = useGetVoteQuery({ date: currentDate, region: currentLocation, empId: null }, { skip });
  const [snacksVoteData, setSnacksVoteData] = useState(null);
  const handleOpen = () => {
    setDialog(true);
  };

  const handleClose = () => {
    setDialog(false);
  };

  const handleNavigateBack = () => {
    logout();
    localStorage.removeItem('location');
    clearAuth(dispatch);
    navigate('/auth');
  };

  // Fetch and listen for Today's Data
  useEffect(() => {
    if (scannedData) {
      setIsPrimaryLoading(false);
      setHighlightIndex(0);
      if (scannedData?.dailyData?.length > 0 && scannedData?.totalCount) {
        setScannedUsers(scannedData.dailyData);
        if (currentLocation == 'Ahmedabad') {
          setScannedCount(scannedData.totalCount);
        } else {
          const { Healthy, ...rest } = scannedData.totalCount; // remove 'Healthy'
          const updatedTotalCount = { ...rest, totalVotes: snacksVoteData?.length || 0 }; // add new key with value 15
          setScannedCount(updatedTotalCount);
        }
      } else {
        setScannedUsers([]);
        if (currentLocation == 'Ahmedabad') {
          setScannedCount(0);
        } else {
          setScannedCount({
            morning: 0,
            evening: 0,
            snack: 0,
            totalVotes: snacksVoteData?.length || 0,
          });
        }
      }
    }
  }, [scannedData, selectedFloor, snacksVoteData]);
  useEffect(() => {
    if (attendanceData) {
      setAttendanceLength(attendanceData.length);
    }
  }, [attendanceData, selectedFloor]);

  //fetched vote data
  useEffect(() => {
    if (!snacksVoteLoading && !snacksVoteError && snacksVote) {
      setSnacksVoteData(snacksVote.data);
      setIsLoading(false);
    } else if (snacksVoteLoading) {
      setIsLoading(true);
    }
  }, [snacksVote, snacksVoteLoading]);

  // Fetch Filtered Data from Firebase
  useEffect(() => {
    if (!dataOfDateRangeLoading && !dataOfDateRangeError && dataOfDateRange) {
      setProcessedData(dataOfDateRange);
      setIsPrimaryLoading(false);
    } else if (dataOfDateRangeLoading) {
      setIsPrimaryLoading(true);
    }
  }, [dataOfDateRangeLoading, dataOfDateRangeError, dataOfDateRange]);
  useEffect(() => {
    if (!dataOfReviewDateRangeLoading && !dataOfReviewDateRangeError && dataOfReviewDateRange) {
      setRatingData(dataOfReviewDateRange?.data);
      setIsPrimaryLoading(false);
    } else if (dataOfDateRangeLoading) {
      setIsPrimaryLoading(true);
    }
  }, [dataOfReviewDateRange, dataOfReviewDateRangeError, dataOfReviewDateRangeLoading]);

  useEffect(() => {
    if (!snacksLoading && !snacksError && snacksData?.length > 0) {
      setIsSnackEntered(true);
    } else {
      setIsSnackEntered(false);
    }
  }, [snacksData]);

  useEffect(() => {
    if (!regionSnacksLoading && !regionSnacksError && regionSnacks) {
      let currentLocation = !selectedLocation ? location : selectedLocation;
      if (currentLocation != 'Ahmedabad' && regionSnacks.data == null) {
        setIsSnackEntered(false);
      }
      setRegionSnacksData(regionSnacks.data);

      setIsLoading(false);
    } else if (regionSnacksLoading) {
      setIsLoading(true);
    }
  }, [regionSnacks, regionSnacksLoading]);

  let isOperating = false;
  let token = 0;
  // socket.on('new-vote-added', (response) => {
  //   let currentLocation = !selectedLocation ? location : selectedLocation;
  //   if (response.region == currentLocation) {
  //     snacksVoteDataRefetch();
  //   }
  // });

  useEffect(() => {
    const handler = (response) => {
      const currentLoc = selectedLocation ?? location;
      if (response.region === currentLoc && !isUninitialized) {
        snacksVoteDataRefetch();
      }
    };

    socket.on('new-vote-added', handler);
    return () => socket.off('new-vote-added', handler);
  }, [socket, selectedLocation, location, isUninitialized, snacksVoteDataRefetch]);

    socket.on('region-snacks-added', (response) => {
      const currentLoc = selectedLocation ?? location;
      if (response.region === currentLoc && !isUninitialized) {
        snacksVoteDataRefetch();
      }
    })

  const handleScanned = async (data) => {
    // ** UNCOMMENT THIS FOR EVENT ATTENDANCE **
    // console.log('qrdata', data);
    if (selectedFloor == 3 && !data) {
      toast.error('Invalid QR Code', { id: 'invalid-qr-code' });
      return;
    }
    if (selectedFloor == 3) {
      if (data) {
        console.log('qrdata', data);
        await toast.promise(addAttendance({ qrData: data }).unwrap(), {
          loading: 'Adding...',
          success: 'Scanned',
          error: (err) => err.data?.message || 'Error in scanning.',
        });
        refetchAttendance();
        return;
      }
      return;
    }
    // setIsLoading(true)
    if (data.date && data.empId && data.token && data.name && data.product && data.socketId) {
      let arg = {
        floor: selectedLocation
          ? selectedLocation == 'Ahmedabad'
            ? selectedFloor
            : 1
          : location == 'Ahmedabad'
          ? selectedFloor
          : 1,
        ...data,
      };
      if (!data.staff && arg.token == token) {
        toast.error('Already Scanned');
        // setIsLoading(false)
      } else if (selectedLocation !== data.region) {
        toast.error('Invalid QR Code', { id: 'invalid-qr-code' });
        // setIsLoading(false)
      } else {
        token = arg.token;

        if (data.staff) {
          const response = await addScannedData(arg).unwrap();
          if (response == 'Already scanned' || response == 'Not allowed') {
            toast.error(response);
          } else {
            toast.success('Scanned');
          }
          return;
        }
        await toast.promise(addScannedData(arg).unwrap(), {
          loading: 'Adding...',
          success: 'Scanned',
          error: (err) => err.data?.message || 'Error in scanning.',
        });
        // setIsLoading(false)
      }
    } else {
      if (invalidQrCount.current < 2) {
        toast.error('Invalid QR Code', { id: 'invalid-qr-code' });
        invalidQrCount.current++;

        setTimeout(() => {
          invalidQrCount.current = 0;
        }, 1000); // reset count after 10 seconds
      }
    }
  };

  // Highlight the topmost card for 5 seconds
  useEffect(() => {
    const highlightTimeout = setTimeout(() => {
      setHighlightIndex(null);
    }, 5000);

    return () => {
      clearTimeout(highlightTimeout);
    };
  }, [highlightIndex]);

  // Camera Visibility Change
  useEffect(() => {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') setIsCameraOpen(false);
      if (document.visibilityState === 'visible') setIsCameraOpen(true);
    });

    return () => {
      document.removeEventListener('visibilitychange', () => {
        setIsCameraOpen(false);
      });
    };
  }, []);

  const scannedById = useMemo(() => {
    return new Map((scannedUsers ?? []).map((u) => [u.empId, u]));
  }, [scannedUsers]);

  const sortedData = useMemo(() => {
    if (!Array.isArray(snacksVoteData)) return [];
    // copy BEFORE sorting to avoid mutating a frozen array
    const copy = [...snacksVoteData];

    return copy.sort((a, b) => {
      const aModified = scannedById.get(a.empId)?.modified;
      const bModified = scannedById.get(b.empId)?.modified;

      // Move items without modified to the bottom
      if (!aModified && !bModified) return 0;
      if (!aModified) return 1;
      if (!bModified) return -1;

      // Ascending by time
      return new Date(bModified).getTime() - new Date(aModified).getTime();
    });
  }, [snacksVoteData, scannedById]);

  const renderScannedRecords = () => {
    return (
      <div>
        {scannedUsers?.length > 0 ? (
          scannedUsers.map((user, index) => (
            <DetailsCard
              user={user}
              key={index}
              id={index}
              highlightIndex={highlightIndex}
              selectedFloor={selectedFloor}
            />
          ))
        ) : (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <h6>No Data Found!</h6>
          </div>
        )}
      </div>
    );
  };
  const snackEntry = Object.entries(scannedCount ?? {}).find(([k]) => k.trim().toLowerCase() === 'snack');

  return (
    <Grid p={1} sx={{ width: '100%' }}>
      <NavbarLayout backButton={false}>
        <Grid display={'flex'} justifyContent={'space-between'} width={'100%'}>
          <Grid item display={'flex'} justifyContent={'start'}>
            <FastfoodOutlined sx={variants.icon.active} />
            <Typography component={'div'} ml={1}>
              Delights{' '}
              <Typography
                sx={{
                  fontSize: variants.BODY,
                  [theme.breakpoints.down('lg')]: {
                    fontSize: variants.TINY,
                  },
                }}
              >
                Having a treat is not a bad idea
              </Typography>
            </Typography>
          </Grid>
          <Button onClick={handleOpen}>Logout</Button>
        </Grid>
      </NavbarLayout>

      {!selectedLocation && !isLocationSelected && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, justifyContent: 'center', alignItems: 'center' }}>
          <img src={locationIcon} width={'30%'} style={{ margin: '5%' }} />

          <Typography style={{ color: '#0A4FAC', fontSize: '24px', fontWeight: 'bold' }}>Your Location ?</Typography>
          <Typography style={{ color: 'grey', fontSize: '14px' }}>
            Kindly choose your location from the list below.
          </Typography>
          <FormControl fullWidth>
            <InputLabel id="location-label">Location</InputLabel>
            <Select
              labelId="location-label"
              id="location-select"
              value={location}
              label="Location"
              onChange={(e) => {
                setLocation(e.target.value);
              }}
            >
              {locations.map((loc, index) => (
                <MenuItem key={index} value={loc}>
                  {loc}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            variant="contained"
            fullWidth
            sx={{ borderRadius: '25px', margin: '5%' }}
            onClick={() => {
              if (!location) {
                toast.error('Please select a location');
                return;
              }
              setIsLocationSelected(true);
              localStorage.setItem('location', location);
            }}
          >
            Done
          </Button>
        </Box>
      )}
      {(selectedLocation || isLocationSelected) && (
        <Box sx={{ p: 2, width: '100%', height: `93vh`, overflow: 'auto' }}>
          <Box display={'flex'} sx={{ width: '100%', overflowX: 'scroll' }}>
            <Tabs
              style={{ flexGrow: 1, width: 'auto', overflowX: 'scroll' }}
               // variant="fullWidth"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
              value={selectedFloor}
              onChange={(a, v) => {
                setSelectedFloor(v);
              }}
            >
               <Tab label="Event" value={3} style={{ fontWeight: 'bolder' }} />
              <Tab
                label={
                  !selectedLocation
                    ? location == 'Ahmedabad'
                    : selectedLocation == 'Ahmedabad'
                    ? 'All'
                    : selectedLocation
                    ? selectedLocation
                    : location
                }
                value={0}
                style={{ fontWeight: 'bolder' }}
              />
             

              {(selectedLocation ? selectedLocation == 'Ahmedabad' : location == 'Ahmedabad') && (
                <Tab label="Terrace" value={1} style={{ fontWeight: 'bolder' }} />
              )}
              {(selectedLocation ? selectedLocation == 'Ahmedabad' : location == 'Ahmedabad') && (
                <Tab label="Ground" value={2} style={{ fontWeight: 'bolder' }} />
              )}
            </Tabs>
            <MenuButton scannedData={scannedUsers?.length} location={currentLocation} currentDate={currentDate} />
          </Box>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '15px',
            }}
          >
            {selectedFloor != 0 ? (
              <div
                ref={qrScannerRef}
                className="d-flex align-items-center justify-content-center"
                style={{
                  borderRadius: '10px',
                  boxShadow: '0px 0px 10px 0px #000000',
                  overflow: 'hidden',
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {isSnackEntered ? (
                  isCameraOpen && (
                    <QrScanner
                      onScan={!isLoading ? handleScanned : null}
                      setSnackbarData={setSnackbarData}
                      isLoading={isLoading}
                      floor={selectedFloor}
                    />
                  )
                ) : (selectedFloor == 4 || selectedFloor == 3) ? (
                  isCameraOpen && (
                    <QrScanner
                      onScan={!isLoading ? handleScanned : null}
                      setSnackbarData={setSnackbarData}
                      isLoading={isLoading}
                      floor={selectedFloor}
                    />
                  )
                ) : (
                  <div
                    style={{
                      height: '400px',
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <SnackDataForm
                      setIsSnackEntered={setIsSnackEntered}
                      isAhmedabadOffice={selectedLocation ? selectedLocation == 'Ahmedabad' : location == 'Ahmedabad'}
                    />
                  </div>
                )}
              </div>
            ) : (
              <div
                style={{
                  height: 'auto',
                  zIndex: '1100',
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <DateRangePicker
                  className="w-100 d-flex justify-content-between align-items-center"
                  onChange={(date) => {
                    setDateRangeFilter(date);
                    setDateFilter(null);
                  }}
                  value={dateRangeFilter}
                  calendarClassName="card"
                  maxDate={new Date()}
                  calendarIcon={<CalendarIcon color="inherit" style={{ color: '#212529' }} />}
                  openCalendarOnFocus={false}
                  clearIcon={null}
                  format="dd-MM-yyyy"
                  rangeDivider=" to  "
                  dayPlaceholder="dd"
                  monthPlaceholder="mm"
                  yearPlaceholder="yyyy"
                />

                {(!selectedLocation ? location != 'Ahmedabad' : selectedLocation != 'Ahmedabad') &&
                  (regionSnacksData?.snack || isSnackEntered) &&
                  isCameraOpen && (
                    <div
                      ref={qrScannerRef}
                      className="d-flex align-items-center justify-content-center"
                      style={{
                        borderRadius: '10px',
                        boxShadow: '0px 0px 10px 0px #000000',
                        overflow: 'hidden',
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBlock: '20px',
                      }}
                    >
                      {
                        <QrScanner
                          onScan={!isLoading ? handleScanned : null}
                          setSnackbarData={setSnackbarData}
                          isLoading={isLoading}
                          floor={selectedFloor}
                        />
                      }
                    </div>
                  )}
                {!selectedLocation
                  ? location != 'Ahmedabad'
                  : selectedLocation != 'Ahmedabad' &&
                    !isSnackEntered &&
                    !regionSnacksData?.snack && (
                      <div
                        style={{
                          borderRadius: '10px',
                          boxShadow: '0px 0px 10px 0px #000000',
                          overflow: 'hidden',
                          width: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginBlock: '20px',
                          height: '400px',
                        }}
                      >
                        <SnackDataForm
                          setIsSnackEntered={setIsSnackEntered}
                          isAhmedabadOffice={
                            selectedLocation ? selectedLocation == 'Ahmedabad' : location == 'Ahmedabad'
                          }
                        />
                      </div>
                    )}
              </div>
            )}

            {selectedFloor !== 3 && (
              <div
                style={{
                  borderRadius: '10px 10px 10px 10px',

                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-around',
                  alignItems: 'center',
                  marginTop: '10px',
                }}
              >
                {Object.keys(scannedCount || {}).map((key, index) => (
                  <Fab
                    size="large"
                    key={index}
                    variant="extended"
                    style={{ margin: '5px' }}
                    onClick={() => {
                      if (key == 'totalVotes') {
                        setVotesPopup(true);
                      }
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <h1 style={{ lineHeight: 0.5, marginBottom: '-15px', marginTop: '25px', textAlign: 'center' }}>
                        {scannedCount[key]}
                      </h1>
                      <p
                        className="text-muted text-capitalize"
                        style={{ textTransform: 'capitalize', color: 'GrayText' }}
                      >
                        {key}
                      </p>
                    </div>
                  </Fab>
                ))}
              </div>
            )}
          </div>
          {selectedFloor === 0 && getDDMMYYYY(dateRangeFilter[0]) !== getDDMMYYYY(dateRangeFilter[1]) && (
            <div>
              <UserDataTable
                scannedData={processedData}
                ratingData={ratingData}
                from={getDDMMYYYY(dateRangeFilter[0].getTime())}
                to={getDDMMYYYY(dateRangeFilter[1].getTime())}
              />
            </div>
          )}
          <CustomTabPanel value={selectedFloor} index={0}>
            {renderScannedRecords()}
          </CustomTabPanel>
          <CustomTabPanel value={selectedFloor} index={1}>
            {renderScannedRecords()}
          </CustomTabPanel>
          <CustomTabPanel value={selectedFloor} index={2}>
            {renderScannedRecords()}
          </CustomTabPanel>
          <CustomTabPanel value={selectedFloor} index={3}>
            {/* {renderScannedRecords()} */}
            {selectedFloor === 3 && <div>Total Attendace : {attendanceLength || 0}</div>}
          </CustomTabPanel>

          {/* {selectedFloor === 3 && <div>Total Attendace : {attendanceLength || 0}</div>} */}
        </Box>
      )}

      <Snackbar open={Boolean(snackbarData?.message)} autoHideDuration={2000} onClose={() => setSnackbarData(null)}>
        {snackbarData?.severity && (
          <Alert
            onClose={() => setSnackbarData(null)}
            severity={snackbarData?.severity || 'info'}
            variant="filled"
            sx={{ width: '100%' }}
          >
            {snackbarData?.message}
          </Alert>
        )}
      </Snackbar>

      <Dialog
        open={dialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{'Logout'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">Are you sure you want to log out ?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>No</Button>
          <Button onClick={handleNavigateBack} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <LikesModal
        open={openVotesPopup}
        onClose={() => {
          setVotesPopup(false);
        }}
        title={'Votes'}
        isAnotherScreen={true}
        likes={snacksVoteData}
        loading={snacksVoteLoading}
      />

      {isPrimaryLoading && (
        <Backdrop
          open={true}
          style={{
            zIndex: 10000,
            color: 'white',
          }}
        >
          <CircularProgress color={'inherit'} size={'50px'} />
        </Backdrop>
      )}
    </Grid>
  );
};

const CustomTabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ height: index == 0 ? `650px` : `440px`, overflow: 'scroll' }}
    >
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
};

const MenuButton = ({scannedData,location,currentDate}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
      <IconButton id="long-button" aria-describedby="more" onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Popover
        id="more"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <EditSnackForm  isEditable= {scannedData == 0} locationData={location}  currentDate={currentDate}/>
      </Popover>
    </div>
  );
};

export default VendorPage;
